module.exports = __webpack_public_path__ + "static/media/close-blue.7331b3d5.svg";